import React from "react";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./ProfileCard.css";

export default function ProfileCard({ name, image, role, description, socialLinks }) {
  const iconMap = {
    linkedin: <FaLinkedin />,
    envelope: <FaEnvelope />,
  };

  return (
    <div className="team-card">
      <img src={image} alt={name} className="team-image" />
      <div className="team-info">
        <h3 className="team-name">{name}</h3>
        <p className="team-role">{role}</p>
        <p className="team-description">{description}</p>
        <ul className="team-social">
          {socialLinks.map(({ platform, link }, idx) => (
            <li key={idx}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {iconMap[platform]}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
